/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateProjectPenaltyTemplateCommand } from '../../models/update-project-penalty-template-command';
import { UpdateProjectPenaltyTemplateCommandResult } from '../../models/update-project-penalty-template-command-result';

export interface ApiProjectPenaltiesTemplateUpdateProjectPenaltyTemplatePost$Params {
      body?: UpdateProjectPenaltyTemplateCommand
}

export function apiProjectPenaltiesTemplateUpdateProjectPenaltyTemplatePost(http: HttpClient, rootUrl: string, params?: ApiProjectPenaltiesTemplateUpdateProjectPenaltyTemplatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProjectPenaltyTemplateCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectPenaltiesTemplateUpdateProjectPenaltyTemplatePost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateProjectPenaltyTemplateCommandResult>;
    })
  );
}

apiProjectPenaltiesTemplateUpdateProjectPenaltyTemplatePost.PATH = '/api/ProjectPenaltiesTemplate/UpdateProjectPenaltyTemplate';
